import React, {useState} from 'react';
import classNames from 'classnames';
import {Shop} from 'interfaces';
import {Flex, Text} from 'components/UIKit';
import {ListingCard, CardMetricTypes} from '../ListingCard';
import {ViewToggleButtons} from './components';
import * as styles from './ListingCards.scss';

export type ListCardsLayoutsTypes = 'list' | 'grid';
export interface ListingCardsProps {
  shops: Shop[];
  group?: string;
  loading?: boolean;
  countString?: string;
  layout?: ListCardsLayoutsTypes;
  metricsToShow?: CardMetricTypes[];
}

export interface ListingCardsState {
  showImage: boolean;
}

export function ListingCards({
  shops,
  group,
  loading,
  countString,
  layout = 'list',
  metricsToShow,
}: ListingCardsProps) {
  const grid = layout === 'grid';
  const [showImage, setShowImage] = useState(true);
  const showCountString = Boolean(countString);
  const gridClassNames = grid && [styles.desktopQuarters, styles.tabletHalves];

  const handleToggleActiveView = () => setShowImage((showImage) => !showImage);

  return (
    <>
      <Flex alignItems="center" justifyContent={showCountString ? 'space-between' : 'flex-end'}>
        {showCountString && <Text text={countString} component="p" />}
        <ViewToggleButtons
          activeView={showImage ? 'image' : 'graph'}
          onToggleClick={handleToggleActiveView}
        />
      </Flex>
      <ul className={classNames(styles[layout], gridClassNames)}>
        {shops.map((shop) => (
          <ListingCard
            key={shop.handle}
            shop={shop}
            group={group}
            loading={loading}
            showImage={showImage}
            layout={layout}
            metricsToShow={metricsToShow}
          />
        ))}
      </ul>
    </>
  );
}
